import React from 'react';

export default ({ color = '#CCCCCC' }) => (
    <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28 19C28 14 24 10 19 10C14 10 10 14 10 19C10 24 14 28 19 28C24 28 28 24 28 19ZM19 28H3.39999C6.49999 33.4 12.3 37 19 37C25.7 37 31.5 33.4 34.6 28H19Z" stroke={color} strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1 19C1 9.1 9.1 1 19 1C28.9 1 37 9.1 37 19" stroke={color} strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
);
